/**
 * Whether a visit belongs to the standing-orders workflow (NurseCareVisitFlow).
 *
 * The workflow's department can be named for a nurse OR a tech (paramedic/EMT) —
 * e.g. "Nurse Care", "Tech Care", "Nurse or Tech Care" — so we match either
 * substring, the same convention used for "ear"/"mental"/"hospital" routing.
 */
export const isNurseTypeOfCare = (typeOfCare?: string): boolean => {
  const value = typeOfCare?.toLowerCase() || "";
  return value.includes("nurse") || value.includes("tech");
};
